export default __webpack_public_path__ + "static/media/social-icon-linkedin.2b46275a.svg";